import { render, staticRenderFns } from "./BrStatusBadge.vue?vue&type=template&id=c4de3788&"
import script from "./BrStatusBadge.vue?vue&type=script&lang=js&"
export * from "./BrStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports